import React from "react";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "react-bootstrap";
import logo from "../../assets/images/logo/app-logo.svg";
import Button from "../../components/global/button/Button";
import { useNavigate } from "react-router-dom";
import RoutingPaths from "../../utils/RoutingPaths";

export default function Welcome(props) {
  const navigate = useNavigate();

  return (
    <Modal
      size="md"
      centered
      show={props.show}
      // onHide={props.onHide}
      dialogClassName=""
    >
      <ModalHeader className="justify-content-center">
        <div>
          <img src={logo} alt="" height="30" className="ms-4 text-center" />
          <h6 className="mt-2 txt-secondary text-center">Welcome to DocPro</h6>
          <h6 className="mb-0 text-muted text-center">Lets get start with</h6>
        </div>
      </ModalHeader>

      <ModalBody>
        <h6 className="text-center">
          You have access to our <span className="txt-success">Free Plan</span>,
          So feel free to enjoy it. To get started, we kindly ask you to
          complete a few steps to set up your profile. Please provide your
          address in order to proceed.
        </h6>
      </ModalBody>

      <ModalFooter className="justify-content-center">
        <Button
          onClick={() => {
            props.onHide();
            navigate(RoutingPaths.ADD_ADDRESS_AND_TIMINGS);
          }}
        >
          Yes
        </Button>
      </ModalFooter>
    </Modal>
  );
}
